export const ONLINE_SCOREBOARD = {
  title: "Tableau de score en ligne",
  subtitle: "Accès gratuit depuis MonAppliTournoi",
  badge: "Nouveauté",
  image: "https://www.scoreboard-judo-club.fr/img/score_public.png",
  url: "https://www.scoreboard-judo-club.fr/tableau-de-score",
  primaryAction: "Ouvrir le tableau de score",
  description:
    "Un tableau de score de judo accessible directement depuis un navigateur, sans créer de compétition ni gérer de distributions.",
  highlights: [
    "Accès gratuit et immédiat.",
    "Aucune inscription nécessaire.",
    "Mode visiteurs simple à afficher sur un écran dédié.",
    "Judoka 1 rouge contre Judoka 2 blanc.",
    "Idéal pour animations, stages, randoris et challenges internes.",
    "Gestion du temps, Golden Score, Osaekomi et valeurs de score.",
  ],
};

export const ANDROID_SCOREBOARD = {
  title: "JudoScore Pro Android",
  subtitle: "Application mobile sur Google Play",
  badge: "Application Android",
  logo: "/images/judoscorepro/logo_scoreboard_judo.png",
  googlePlayLogo: "/images/judoscorepro/Google-Play-Logo.png",
  url: "https://play.google.com/store/apps/details?id=com.victorin.judoscorepro",
  primaryAction: "Voir sur Google Play",
  description:
    "Une application Android pratique pour tenir les scores de judo sur smartphone ou tablette, avec chronomètres, pénalités et réglages de combat.",
  highlights: [
    "Tableau de score intuitif.",
    "Gestion Ippon, Waza-ari, Shido et Hansoku-make.",
    "Chronomètres personnalisables.",
    "Alertes sonores.",
    "Réglages de durée, langue et mode de compétition.",
  ],
};

export const SCOREBOARD_SCREENSHOTS = [
  {
    src: "/images/judoscorepro/judoscore01.png",
    alt: "Tableau de score JudoScore Pro",
    caption: "Tableau de score",
  },
  {
    src: "/images/judoscorepro/judoscore02.png",
    alt: "Mode d'emploi JudoScore Pro",
    caption: "Mode d'emploi",
  },
  {
    src: "/images/judoscorepro/judoscore03.png",
    alt: "Réglages JudoScore Pro",
    caption: "Réglages",
  },
  {
    src: "/images/judoscorepro/judoscore04.png",
    alt: "Sélection des langues JudoScore Pro",
    caption: "Sélection des langues",
  },
];